import { CardContainer } from "./CardContainer"
import { CardStat } from "./CardComps"

const FeePayCard = ({ data }) => (
  <CardContainer
    disableEditDelete
    SummaryContent={
      <>
        <CardStat label="Institute Id" value={data.instituteId} />
        <CardStat label="Name" value={data.name} />
        <CardStat label="Enrollment Status" value={data.enrollmentStatus} />
        <CardStat label="Year" value={data.year} />
        <CardStat label="Balance" value={"₹" + (data.totalBalance || 0)} />
      </>
    }
    DetailsContent={
      <>
        <CardStat label="Total admission fee" value={"₹" + (data.totalFee || 0)} />
        <CardStat label="Fee Collected" value={"₹" + (data.totalCollected || 0)} />
        <CardStat label="Next Due Date" value={data.nextDueDate} />
      </>
    }
  />
)

export default FeePayCard
